<template>
    <BreadCrumb PageTitle="Créer une session" />
    <FaireTest />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import FaireTest from "@/components/Session/FaireTest.vue";
   
  
    export default defineComponent({
      name: "FaireTestPage",
      components: {
        BreadCrumb,
        FaireTest,
      },
    });
  </script>